<template>
    <section id="page-intro" class="page-intro page">
        <div class="page__content">
            <h1>Een hybride auto ken je</h1>
            <p id="page-intro__text-1">Een voertuig dat door een combinatie van twee krachtbronnen...</P>
            <div id="page-intro__animation-area" class="animation-area">
                <div class="animation-area__center">
                    <img id="page-intro__fuel" src="../../assets/icons/fuel tank.svg" class="page-intro__animated-item">
                    <img id="page-intro__plus" src="../../assets/icons/plus.svg" class="page-intro__animated-item">
                    <img id="page-intro__plug" src="../../assets/icons/plug.svg" class="page-intro__animated-item">
                </div>
            </div>
            <p id="page-intro__text-2">... wordt aangedreven</p>
            <div id="page-intro__next-btn">
                <page-next-button
                        v-on:click="nextHandler"></page-next-button>
            </div>
        </div>
    </section>
</template>
<style lang="stylus">
    #page-intro
        margin-bottom 50vh

    #page-intro .animation-area__center
        height 70px

    .page-intro__animated-item
        position absolute

    #page-intro__text-1
        opacity 0

    #page-intro__text-2
        opacity 0
        margin-top 60px

    #page-intro__fuel
        height 120px
        left calc(-50vw - 100px)

    #page-intro__plus
        height 70px
        top 25px
        left -35px
        transform scale(0)

    #page-intro__plug
        height 120px
        right calc(-50vw - 100px)

    #page-intro__next-btn
        opacity 0

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');

    import page from './page';

    export default {
        mixins: [page],
        data() {
            return {
            }
        },
        methods: {
            initAnimation() {
                const tween = new TimelineMax()
                    .to("#page-intro__text-1", .5, {opacity: 1})
                    .to("#page-intro__fuel", .3, {left: -160})
                    .to("#page-intro__plug", .3, {right: -150})
                    .to("#page-intro__plus", .3, {transform: "scale(1)"})
                    .to("#page-intro__text-2", .8, {opacity: 1})
                    .to("#page-intro__next-btn", .8, {opacity: 1, delay: .5});

                const scene = new ScrollMagic.Scene( {
                        triggerElement: '#page-intro'
                    })
                    .setPin('#page-intro')
                    .setTween(tween)
                    .addTo(this.scroller);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// page-intro.vue?50a58e77